import { Activity, Clock, MousePointerClick, AlertTriangle, MessageSquare, Flame, Layers, GraduationCap } from "lucide-react";
import { ago } from "./util";

const Tile = ({ icon: I, k, v, tone = "text-brand", i }) => (
  <div className="border-r border-b border-white/10 p-4 animate-in fade-in slide-in-from-bottom-2 duration-500" style={{ animationDelay: `${i * 50}ms`, animationFillMode: "both" }} data-testid={`kpi-${k.toLowerCase().replace(/[^a-z]/g, "-")}`}>
    <p className="label-xs flex items-center gap-1.5"><I className="w-3 h-3" />{k}</p>
    <p className={`font-mono text-2xl font-extrabold mt-1 tabular-nums ${tone}`}>{v}</p>
  </div>
);

export const Header = ({ d, userId, setUserId, days, setDays }) => {
  const k = d.kpis;
  const tiles = [[Layers, "Sessions", k.sessions], [Clock, "Active min", k.active_min], [Clock, "Avg session min", k.avg_session_min],
    [MousePointerClick, "Clicks", k.clicks], [AlertTriangle, "Errors", k.errors, k.errors ? "text-red-400" : "text-brand"],
    [MessageSquare, "MARI questions", k.mari_questions, "text-amber-300"], [Flame, "High friction", k.friction_high, k.friction_high ? "text-[#FF2BD6]" : "text-brand"],
    [GraduationCap, "Training", k.training, "text-accent2"]];
  return (
    <section className="panel overflow-hidden" data-testid="insights-header">
      <div className="flex flex-wrap items-center gap-4 p-5 border-b border-white/10 bg-gradient-to-r from-brand/[0.04] to-transparent">
        <div className="relative w-11 h-11 grid place-items-center border border-white/15">
          <Activity className="w-5 h-5 text-brand" />
          {d.online && <span className="absolute -top-1 -right-1 w-3 h-3"><span className="absolute inset-0 rounded-full bg-brand animate-ping opacity-70" /><span className="absolute inset-0 rounded-full bg-brand" /></span>}
        </div>
        <div className="flex-1 min-w-[200px]">
          <p className="font-bold text-lg" data-testid="insights-user-name">{d.user.name} <span className="text-white/40 font-normal text-sm">{d.user.email}</span></p>
          <p className="font-mono text-[11px] mt-0.5" data-testid="insights-presence">
            {d.online ? <span className="text-brand">● LIVE NOW · on {d.current_page}</span> : <span className="text-white/45">○ offline · last seen {ago(d.last_seen)}{d.current_page ? ` on ${d.current_page}` : ""}</span>}
          </p>
        </div>
        <select value={userId || d.user.id} onChange={(e) => setUserId(e.target.value)} className="bg-black/60 border border-white/15 px-3 py-2 font-mono text-xs" data-testid="insights-user-select">
          {d.users.map((u) => <option key={u.id} value={u.id}>{u.name || u.email}{u.is_platform_admin ? " (admin)" : ""}</option>)}
        </select>
        <div className="flex border border-white/15" data-testid="insights-range">
          {[1, 7, 30, 90].map((n) => (
            <button key={n} onClick={() => setDays(n)} className={`px-3 py-2 font-mono text-[11px] transition-colors ${days === n ? "bg-brand text-black" : "text-white/60 hover:text-white"}`} data-testid={`insights-range-${n}`}>{n}D</button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 border-l border-t border-white/10 -mb-px -mr-px">
        {tiles.map(([I, key, v, tone], i) => <Tile key={key} icon={I} k={key} v={v} tone={tone} i={i} />)}
      </div>
    </section>
  );
};
